import axios from 'axios';

// Crée une instance Axios qui ajoute automatiquement le token JWT
const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Intercepter les requêtes et ajouter le token JWT
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers['Token'] = `${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response.status === 401) {
            localStorage.removeItem('token');  // Supprimer le token expiré
            window.location.href = '/login';  // Redirect to login page
        }
        return Promise.reject(error);
    }
);

export default api;
